class MongoRequestHandler {
    constructor() {
        this.NODE_SERVER_BASE_URL = "https://eai.lmc.gatech.edu/app";
    }

    async fetchProcessHistory(username, historySource, limit){
        try {
            const response = await fetch(`${this.NODE_SERVER_BASE_URL}/api/retrieve_history`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ username: username, historySource: historySource, limit: limit }),
            });

            if (response.ok) {
                const data = await response.json();
                console.log('Successfully retrieved history, data: ', data);
                return data;
            } else {
                console.error('Failed to retrieve history');
            }
        } catch (error) {
            console.error('Error retrieving history:', error);
        }
    };
    
    async handleInsertHistory(data) {
        try {
          const response = await fetch(`${this.NODE_SERVER_BASE_URL}/api/insert_history`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
          });
    
          if (response.ok) {
            const result = await response.json();
            console.log('Successfully inserted to process history');
            return result;
          } else {
            console.error('Failed to insert to process history');
          }
        } catch (error) {
          console.error('Error:', error);
        }
    };


    async handleInsertSampleImage(data) {
        try {
          const response = await fetch(`${this.NODE_SERVER_BASE_URL}/api/insert_sample_image`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
          });
    
          if (response.ok) {
            const result = await response.json();
            return result;
          } else {
            console.error('Failed to insert to sample images');
          }
        } catch (error) {
          console.error('Error:', error);
        }
    };


    async fetchSampleImageById(imageId) {
        try {
            const response = await fetch(`${this.NODE_SERVER_BASE_URL}/api/fetch_sample_image/${imageId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const sample = await response.json();
                console.log('Successfully retrieved sample image:', sample);
                return sample;
            } else if (response.status === 404) {
                console.error('Sample image not found');
            } else {
                console.error('Failed to retrieve sample image');
            }
        } catch (error) {
            console.error('Error retrieving sample image:', error);
        }
    };


    async fetchAllSampleImages(availableFor) {
        try {
            const response = await fetch(`${this.NODE_SERVER_BASE_URL}/api/fetch_all_samples/${availableFor}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.ok) {
                const samples = await response.json();
                console.log('Successfully retrieved sample images:', samples);
                return samples;
            } else {
                console.error('Failed to retrieve sample images');
            }
        } catch (error) {
            console.error('Error retrieving sample images:', error);
        }
    };

    async testServerStatus() {
        try {
            const response = await fetch(`${this.NODE_SERVER_BASE_URL}/api/hello`, {
                method: 'GET'
            });

            if (!response.ok) {
                return false;
            }

            const message = await response.text();
            if (message != "Hey Yo!") {
                return false;
            }

            return true;
        } catch (error) {
            console.error('Error testing server status:', error);
            return false;
        }
    }
}

export default MongoRequestHandler;